import { QueryResponseCamelCase } from 'types'
import { FittingSnapshotRecord } from './types'

type GetFittingSnapshotsResponse = QueryResponseCamelCase<FittingSnapshotRecord>

/**
 * `transformResponse` for the fitting-snapshots endpoint.
 *
 * ⚠️ Client-side defense-in-depth — NOT a true PII boundary. Each wire record carries a
 * decrypted `snapshot` object (patient name, audiogram points, gains, account number). This
 * strip removes `snapshot` before it reaches app code, the react-query cache, or our error
 * reports — real wins. But the field has already crossed the wire to the browser and is
 * briefly materialized in heap by `response.json()` (and is visible in the Network tab), so
 * it does NOT defend against interception, DevTools, or browser storage. The authoritative
 * fix is server-side: ta-device-service should omit `snapshot` for score-only consumers
 * (follow-up — see the PX-3194 PR discussion).
 */
const stripFittingSnapshotPii = async (response: Response): Promise<GetFittingSnapshotsResponse> => {
  const body = await response.json()
  const records: Array<Record<string, unknown>> = Array.isArray(body?.data) ? body.data : []

  const data = records.map((record) => {
    const sanitized = { ...record }

    delete sanitized.snapshot

    return sanitized
  })

  return { ...body, data } as GetFittingSnapshotsResponse
}

export { stripFittingSnapshotPii }
